/**
 * Wrapper of console logger for less code in modules
 */
class Logger {
    constructor() {
        this.muted_ = false;
    }
    time_() {
        return (window.performance) ? window.performance.now().toString() + ' ' : '';
    }
    mute() {
        this.muted_ = true;
    }
    log(name, msg, raw = false, conLog = console.log) {
        if (!this.muted_) {
            if (raw) {
                const logObj = {
                    time: this.time_(),
                    name: name,
                    msg: msg
                };
                conLog(logObj);
            }
            else {
                conLog(`%c${this.time_()}%c[${name}] %c${msg}`, 'color:#aaa;', 'font-weight:bold;', 'color:#369;');
            }
        }
    }
    logUnknownError(error, moduleName, raw = false, conLog = console.error) {
        if (error instanceof Error) {
            this.log(moduleName, error.message, raw, conLog);
        }
        else if (typeof error === 'string') {
            this.log(moduleName, error, raw, conLog);
        }
        else {
            this.log(moduleName, 'error', raw, conLog);
        }
    }
}
const logger = new Logger();
export default logger;
